var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZigzag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 11,
    viewBox: "0 0 67 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C8.19258 7.06244 14.0554 4.76701 20.2656 2.85228C21.2678 2.54328 23.7024 1.56328 23.4813 2.22443C22.8379 4.14794 19.1224 5.52968 18.9313 7.58733C18.8591 8.36355 20.5104 7.68008 21.6437 7.48269C27.4046 6.47938 32.9861 5.24774 38.6188 4.0295C38.7998 3.99033 40.4412 3.80969 40.3031 3.84638C38.3615 4.36239 37.2173 6.01301 36.2125 7.03796C35.4128 7.85369 35.052 8.31819 36.7594 7.86202C41.4562 6.60717 46.0047 5.11964 50.7813 3.97718C51.4256 3.82306 57.1891 2.17766 56.25 3.32317C55.7717 3.90663 54.7625 4.67865 54.7625 5.35061C54.7625 5.43727 54.6753 6.05957 54.85 6.07002C58.299 6.27626 61.6347 4.29111 65 4.29111",
    stroke: "#34A853",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigzag);
export default __webpack_public_path__ + "static/media/zigzag.7e7a3b0e501f67863690ebb6fa4f02f0.svg";
export { ForwardRef as ReactComponent };